import { EmployeeSummary, Timeframe } from "@performyard/service-contracts";

import request from "./internal-base-request";

export const fetchEmployeeSummary = async (userId: string, timeframe: Timeframe): Promise<EmployeeSummary> => {
	const searchParams = new URLSearchParams({ timeframe });
	const [response] = await request<EmployeeSummary>(`/v1/employee-summary/${userId}?${searchParams.toString()}`, {
		method: "GET",
	});
	return response;
};

export const regenerateEmployeeSummary = async (userId: string, timeframe: Timeframe): Promise<EmployeeSummary> => {
	const [response] = await request<EmployeeSummary>(`/v1/employee-summary/${userId}/regenerate`, {
		method: "POST",
		body: JSON.stringify({ timeframe }),
	});
	return response;
};
